module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "changeAvatar"
  }, [_c('vue-avatar', {
    ref: "vueavatar",
    attrs: {
      "width": 500,
      "height": 500,
      "image": _vm.objectUrl,
      "borderRadius": 50000,
      "rotation": _vm.rotation,
      "scale": _vm.scale
    },
    on: {
      "vue-avatar-editor:image-ready": _vm.onImageReady
    }
  }), _c('br'), _c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" " + _vm._s(_vm.$t("changeAvatar.clickToEdit"))), _c('br'), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scale),
      expression: "scale"
    }],
    attrs: {
      "type": "range",
      "width": 200,
      "min": 1,
      "max": 10,
      "step": 0.02
    },
    domProps: {
      "value": (_vm.scale)
    },
    on: {
      "__r": function($event) {
        _vm.scale = $event.target.value
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rotation),
      expression: "rotation"
    }],
    attrs: {
      "type": "range",
      "width": 200,
      "min": 0,
      "max": 360,
      "step": 0.02
    },
    domProps: {
      "value": (_vm.rotation)
    },
    on: {
      "__r": function($event) {
        _vm.rotation = $event.target.value
      }
    }
  }), _c('br'), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.saveClicked
    }
  }, [_vm._v(_vm._s(_vm.$t("globals.save")))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f1c1eb28","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile/ChangeAvatar.vue
// module id = 950
// module chunks = 2 4 5